<template>
  <div v-if="visible" class="fixed inset-0 z-50 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        @click="onClose"
      ></div>
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full"
      >
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
              <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4">
                {{
                  mode === 'create'
                    ? 'Создать аккаунт'
                    : 'Редактировать аккаунт'
                }}
              </h3>
              <form @submit.prevent="submitForm">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Название аккаунта *</label
                    >
                    <input
                      v-model="formData.name"
                      type="text"
                      required
                      class="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      :class="
                        validationErrors.name
                          ? 'border-red-500'
                          : 'border-gray-300'
                      "
                      @input="clearFieldError('name')"
                    />
                    <div
                      v-if="validationErrors.name"
                      class="text-xs text-red-600 mt-1"
                    >
                      {{ validationErrors.name }}
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Агентство</label
                    >
                    <select
                      v-model="formData.agency_id"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Без агентства</option>
                      <option
                        v-for="agency in agencies"
                        :key="agency.id"
                        :value="agency.id"
                      >
                        {{ agency.name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Сайт *</label
                    >
                    <div class="relative flex items-center">
                      <span
                        class="absolute left-3 text-gray-400 select-none pointer-events-none"
                        >http://</span
                      >
                      <input
                        v-model="formData.site"
                        type="text"
                        required
                        placeholder="example.com"
                        class="w-full pl-16 px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        :class="
                          validationErrors.site || siteError
                            ? 'border-red-500'
                            : 'border-gray-300'
                        "
                        @input="onSiteInput"
                        @blur="validateSite"
                      />
                    </div>
                    <div
                      v-if="validationErrors.site || siteError"
                      class="text-xs text-red-600 mt-1"
                    >
                      {{ validationErrors.site || siteError }}
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Класс обслуживания *</label
                    >
                    <select
                      v-model="formData.class_of_service"
                      required
                      class="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      :class="
                        validationErrors.class_of_service
                          ? 'border-red-500'
                          : 'border-gray-300'
                      "
                      @change="clearFieldError('class_of_service')"
                    >
                      <option value="">Выберите класс обслуживания</option>
                      <option value="Base">Base</option>
                      <option value="Pro">Pro</option>
                      <option value="Premium">Premium</option>
                    </select>
                    <div
                      v-if="validationErrors.class_of_service"
                      class="text-xs text-red-600 mt-1"
                    >
                      {{ validationErrors.class_of_service }}
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Тарифная группа *</label
                    >
                    <select
                      v-model="formData.tariff_group"
                      required
                      class="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      :class="
                        validationErrors.tariff_group
                          ? 'border-red-500'
                          : 'border-gray-300'
                      "
                      @change="clearFieldError('tariff_group')"
                    >
                      <option value="">Выберите тарифную группу</option>
                      <option value="Base">Base</option>
                      <option value="Pro">Pro</option>
                      <option value="Premium">Premium</option>
                      <option value="Специальный">Специальный</option>
                      <option value="Enterprise">Enterprise</option>
                      <option value="Demo">Demo</option>
                      <option value="Position">Position</option>
                      <option value="Position Plus">Position Plus</option>
                    </select>
                    <div
                      v-if="validationErrors.tariff_group"
                      class="text-xs text-red-600 mt-1"
                    >
                      {{ validationErrors.tariff_group }}
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >ФИО ЛПР</label
                    >
                    <input
                      v-model="formData.bio_of_dm"
                      type="text"
                      class="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      :class="
                        validationErrors.bio_of_dm
                          ? 'border-red-500'
                          : 'border-gray-300'
                      "
                      @input="clearFieldError('bio_of_dm')"
                    />
                    <div
                      v-if="validationErrors.bio_of_dm"
                      class="text-xs text-red-600 mt-1"
                    >
                      {{ validationErrors.bio_of_dm }}
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Телефон ЛПР</label
                    >
                    <input
                      v-model="formData.tel_of_dm"
                      type="text"
                      class="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      :class="
                        validationErrors.tel_of_dm
                          ? 'border-red-500'
                          : 'border-gray-300'
                      "
                      @input="clearFieldError('tel_of_dm')"
                    />
                    <div
                      v-if="validationErrors.tel_of_dm"
                      class="text-xs text-red-600 mt-1"
                    >
                      {{ validationErrors.tel_of_dm }}
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Telegram ЛПР</label
                    >
                    <input
                      v-model="formData.telegram_of_dm"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Должность ЛПР</label
                    >
                    <select
                      v-model="formData.position_of_dm_id"
                      class="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      :class="
                        validationErrors.position_of_dm_id
                          ? 'border-red-500'
                          : 'border-gray-300'
                      "
                      @change="clearFieldError('position_of_dm_id')"
                    >
                      <option value="">Выберите должность</option>
                      <option
                        v-for="pos in positions"
                        :key="pos.id"
                        :value="pos.id"
                      >
                        {{ pos.name }}
                      </option>
                    </select>
                    <div
                      v-if="validationErrors.position_of_dm_id"
                      class="text-xs text-red-600 mt-1"
                    >
                      {{ validationErrors.position_of_dm_id }}
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Причина ухода</label
                    >
                    <select
                      v-model="formData.reason_of_leaving_id"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Выберите причину</option>
                      <option
                        v-for="reason in reasonsOfLeaving"
                        :key="reason.id"
                        :value="reason.id"
                      >
                        {{ reason.name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Риск отвала</label
                    >
                    <input
                      v-model="formData.risk_of_leaving"
                      type="number"
                      min="0"
                      max="4"
                      placeholder="Введите число от 0 до 4"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      :class="{ 'border-red-500': riskOfLeavingError }"
                      @input="validateRiskOfLeaving"
                      @blur="validateRiskOfLeaving"
                    />
                    <div
                      v-if="riskOfLeavingError"
                      class="text-xs text-red-600 mt-1"
                    >
                      {{ riskOfLeavingError }}
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Аккаунт-менеджер</label
                    >
                    <select
                      v-model="formData.account_manager_id"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Выберите аккаунт-менеджера</option>
                      <option
                        v-for="user in userStore.accountManagers"
                        :key="user.id"
                        :value="user.id"
                      >
                        {{ user.surname }} {{ user.first_name }}
                        {{ user.middle_name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Сейл-менеджер</label
                    >
                    <select
                      v-model="formData.sale_manager_id"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Выберите сейл-менеджера</option>
                      <option
                        v-for="user in userStore.saleManagers"
                        :key="user.id"
                        :value="user.id"
                      >
                        {{ user.surname }} {{ user.first_name }}
                        {{ user.middle_name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Аналитик-лид</label
                    >
                    <select
                      v-model="formData.analytic_lead_id"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Выберите аналитик-лида</option>
                      <option
                        v-for="user in userStore.analyticLeads"
                        :key="user.id"
                        :value="user.id"
                      >
                        {{ user.surname }} {{ user.first_name }}
                        {{ user.middle_name }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Периодичность сбора *</label
                    >
                    <select
                      v-model="formData.frequency_collection"
                      required
                      class="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      :class="
                        validationErrors.frequency_collection
                          ? 'border-red-500'
                          : 'border-gray-300'
                      "
                      @change="clearFieldError('frequency_collection')"
                    >
                      <option value="">Выберите периодичность</option>
                      <option value="1 раз в 2 дня">1 раз в 2 дня</option>
                      <option value="2 раза в неделю">2 раза в неделю</option>
                      <option value="раз в неделю">раз в неделю</option>
                      <option value="специальный">специальный</option>
                    </select>
                    <div
                      v-if="validationErrors.frequency_collection"
                      class="text-xs text-red-600 mt-1"
                    >
                      {{ validationErrors.frequency_collection }}
                    </div>
                  </div>
                </div>
                <div class="mt-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >Комментарии</label
                    >
                    <textarea
                      v-model="formData.description"
                      rows="3"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    ></textarea>
                  </div>
                </div>
                <div class="mt-4">
                  <div class="flex items-center">
                    <input
                      v-model="formData.active"
                      type="checkbox"
                      id="active"
                      class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label
                      for="active"
                      class="ml-2 block text-sm text-gray-700"
                    >
                      Активен
                    </label>
                  </div>
                </div>
                <div
                  class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse mt-6"
                >
                  <button
                    type="submit"
                    :disabled="submitting"
                    class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                  >
                    <span
                      v-if="submitting"
                      class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"
                    ></span>
                    {{ mode === 'create' ? 'Создать' : 'Сохранить' }}
                  </button>
                  <button
                    type="button"
                    @click="onClose"
                    :disabled="submitting"
                    class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                  >
                    Отмена
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, reactive, watch, computed } from 'vue'
  import { useToast } from 'primevue/usetoast'
  import { paymentAccountApi } from '../services/api'

  const toast = useToast()
  const props = defineProps({
    visible: Boolean,
    mode: String,
    account: Object,
    agencies: Array,
    positions: Array,
    reasonsOfLeaving: Array,
    userStore: Object,
    accountManagerUsers: Array,
    onClose: Function,
    onSaved: Function
  })
  const submitting = ref(false)
  const siteError = ref('')
  const riskOfLeavingError = ref('')
  const validationErrors = ref({})
  const formData = reactive({
    name: '',
    description: '',
    agency_id: '',
    site: '',
    account_manager_id: '',
    sale_manager_id: '',
    analytic_lead_id: '',
    class_of_service: '',
    tariff_group: '',
    active: false,
    bio_of_dm: '',
    tel_of_dm: '',
    telegram_of_dm: '',
    position_of_dm_id: '',
    reason_of_leaving_id: '',
    risk_of_leaving: '',
    frequency_collection: ''
  })
  watch(
    () => props.account,
    val => {
      if (val) Object.assign(formData, val)
      else
        Object.assign(formData, {
          name: '',
          description: '',
          agency_id: '',
          site: '',
          account_manager_id: '',
          sale_manager_id: '',
          analytic_lead_id: '',
          class_of_service: '',
          tariff_group: '',
          active: false,
          bio_of_dm: '',
          tel_of_dm: '',
          telegram_of_dm: '',
          position_of_dm_id: '',
          reason_of_leaving_id: '',
          risk_of_leaving: '',
          frequency_collection: ''
        })
    },
    { immediate: true }
  )
  function validateSite() {
    siteError.value = ''
    const val = formData.site

    if (!val || val === '' || (typeof val === 'string' && val.trim() === '')) {
      siteError.value = 'Это поле обязательно для заполнения'
      return
    }

    if (/^[.\-\/]/.test(val)) {
      siteError.value = 'Введите корректный домен, например: example.com'
      return
    }
    if (/\s/.test(val)) {
      siteError.value = 'Введите корректный домен, например: example.com'
      return
    }
    if (!val.includes('.') || val.length < 4) {
      siteError.value = 'Введите корректный домен, например: example.com'
      return
    }
  }

  function validateRiskOfLeaving() {
    riskOfLeavingError.value = ''
    const val = formData.risk_of_leaving

    if (val === '' || val === null || val === undefined) {
      return
    }

    const numVal = Number(val)
    if (isNaN(numVal) || numVal < 0 || numVal > 4) {
      riskOfLeavingError.value = 'Введите число от 0 до 4'
      return
    }
  }
  function onSiteInput(e) {
    let val = e.target.value
    val = val.replace(/^https?:\/\//, '')
    val = val.replace(/[^a-zA-Z0-9.\-\/_]/g, '')
    formData.site = val
    if (validationErrors.value.site) {
      delete validationErrors.value.site
    }
  }

  const clearFieldError = field => {
    if (validationErrors.value[field]) {
      delete validationErrors.value[field]
    }
  }

  function validateForm() {
    validationErrors.value = {}
    let isValid = true

    validateRiskOfLeaving()
    if (riskOfLeavingError.value) {
      isValid = false
    }

    validateSite()
    if (siteError.value) {
      validationErrors.value.site = siteError.value
      isValid = false
    }

    const requiredFields = [
      'name',
      'site',
      'class_of_service',
      'tariff_group',
      'frequency_collection'
    ]

    requiredFields.forEach(field => {
      const value = formData[field]
      if (
        !value ||
        value === '' ||
        value === null ||
        value === undefined ||
        (typeof value === 'string' && value.trim() === '')
      ) {
        validationErrors.value[field] = 'Это поле обязательно для заполнения'
        isValid = false
      }
    })

    return isValid
  }
  async function submitForm() {
    const isValid = validateForm()
    if (!isValid) {
      console.log('Form validation failed:', validationErrors.value)
      toast.add({
        severity: 'error',
        summary: 'Ошибка валидации',
        detail: 'Пожалуйста, заполните все обязательные поля',
        life: 5000
      })
      return
    }

    submitting.value = true
    try {
      const data = { ...formData }
      if (!formData.agency_id) {
        data.agency_id = null
        data.agency_name = null
      }
      if (formData.reason_of_leaving_id) {
        data.reason_of_leaving_id = Number(formData.reason_of_leaving_id)
      } else {
        data.reason_of_leaving_id = null
      }

      // Преобразование ID полей в числа или null
      if (formData.account_manager_id) {
        data.account_manager_id = Number(formData.account_manager_id)
      } else {
        data.account_manager_id = null
      }

      if (formData.sale_manager_id) {
        data.sale_manager_id = Number(formData.sale_manager_id)
      } else {
        data.sale_manager_id = null
      }

      if (formData.analytic_lead_id) {
        data.analytic_lead_id = Number(formData.analytic_lead_id)
      } else {
        data.analytic_lead_id = null
      }

      if (formData.position_of_dm_id) {
        data.position_of_dm_id = Number(formData.position_of_dm_id)
      } else {
        data.position_of_dm_id = null
      }

      if (formData.agency_id) {
        data.agency_id = Number(formData.agency_id)
      }
      data.active = Boolean(formData.active)
      if (
        formData.risk_of_leaving !== '' &&
        formData.risk_of_leaving !== null &&
        formData.risk_of_leaving !== undefined
      ) {
        data.risk_of_leaving = Number(formData.risk_of_leaving)
      } else {
        delete data.risk_of_leaving
      }
      if (data.site && !/^https?:\/\//.test(data.site)) {
        data.site = 'http://' + data.site
      }
      if (props.mode === 'create') {
        await paymentAccountApi.create(data)
      } else {
        await paymentAccountApi.update(formData.id, data)
      }
      if (props.onSaved) props.onSaved()
      props.onClose()
    } catch (err) {
      const errorData = err.response?.data
      let errorMessage = 'Произошла ошибка при сохранении'

      const details = errorData?.data?.details || errorData?.details

      if (details) {
        Object.keys(details).forEach(field => {
          const fieldError = details[field]
          if (Array.isArray(fieldError) && fieldError.length > 0) {
            validationErrors.value[field] = fieldError[0]
          } else if (typeof fieldError === 'string') {
            validationErrors.value[field] = fieldError
          }
        })

        const firstField = Object.keys(details)[0]
        if (firstField) {
          const fieldError = details[firstField]
          if (Array.isArray(fieldError) && fieldError.length > 0) {
            errorMessage = `${firstField}: ${fieldError[0]}`
          } else if (typeof fieldError === 'string') {
            errorMessage = `${firstField}: ${fieldError}`
          }
        }
      } else if (errorData?.data?.message) {
        errorMessage = errorData.data.message
      } else if (errorData?.message) {
        errorMessage = errorData.message
      }

      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: errorMessage,
        life: 5000
      })
    } finally {
      submitting.value = false
    }
  }
</script>
